import script from "./BulkEditConfirmModal.vue?vue&type=script&lang=ts&setup=true"
export * from "./BulkEditConfirmModal.vue?vue&type=script&lang=ts&setup=true"

import "./BulkEditConfirmModal.vue?vue&type=style&index=0&id=017e62e0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-017e62e0"]])

export default __exports__